module.exports = __webpack_public_path__ + "img/materials-and-equipments-requests-manage.6ade89ab.svg";